import { AdapterLink } from "../../../../components/Adopter";
import React from "react";
import { useCallback } from "react";
import { useSnackbar } from "notistack";
import Dialog from "../../../../components/Dialog";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core";
import LabeledContent from "../../../../components/LabeledContent";
import { Routes } from "../../../../constants/routes";
import FontIcon from "../../../../components/FontIcon";
import { ISchool } from "../../types";
import useSchoolQueries from "../../hooks/useSchoolQueries";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "../../../../components/IconButton";
import { mutateErrors } from "../../../../utils";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderBottom: "1px solid #dfdcd6",
    },
  },
  buttonsContainer: {
    display: "flex",
    textAlign: "center",
    justifyContent: "space-between",
  },
  paper: {
    padding: theme.spacing(3),
  },
}));

export default function SchoolListItem({
  index,
  onDelete,
  school,
}: {
  index: number;
  onDelete: Function;
  school: ISchool;
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const { fetchDelete } = useSchoolQueries();

  const handleDelete = useCallback(async () => {
    try {
      await fetchDelete(school.id);
      enqueueSnackbar("Success", { variant: "success" });
    } catch (e) {
      const { message } = mutateErrors(e);
      enqueueSnackbar(message, { variant: "error" });
    }
    if (typeof onDelete == "function") onDelete();
    closeDialog();
  }, [fetchDelete, school]); // eslint-disable-line react-hooks/exhaustive-deps

  const openDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid
            container
            spacing={2}
            justify={"space-between"}
            alignItems={"center"}
          >
            <Grid item xs={12} md={10} className={classes.content}>
              <Grid container spacing={2} alignItems={"center"}>
                <Grid item xs={"auto"}>
                  <Avatar src={school.image} />
                </Grid>
                <Grid item xs={9} sm={5} md={4}>
                  <LabeledContent label={"Name"}>{school.name}</LabeledContent>
                </Grid>
                <Grid item xs={9} sm={5} md={2}>
                  <LabeledContent label={"Type"}>
                    {school.type.name}
                  </LabeledContent>
                </Grid>
                <Grid item xs={9} sm={12} md={5}>
                  <LabeledContent label={"Description"}>
                    {school.description
                      ? `${school.description.slice(0, 55)}...`
                      : ""}
                  </LabeledContent>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={"auto"} className={classes.buttonsContainer}>
              <div>
                <IconButton
                  color={"view"}
                  component={AdapterLink}
                  to={`/0/${Routes.SCHOOLS}/${school.id}`}
                >
                  <FontIcon fontSize={"small"} name={"show"} />
                </IconButton>
              </div>
              <div>
                <IconButton
                  color={"edit"}
                  component={AdapterLink}
                  to={`/0/${Routes.SCHOOLS}/${school.id}/edit`}
                >
                  <FontIcon fontSize={"small"} name={"edit"} />
                </IconButton>
              </div>
              <div>
                <IconButton color={"delete"} onClick={openDialog}>
                  <FontIcon fontSize={"small"} name={"delete"} />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Dialog
        open={dialogOpen}
        title="Are you sure?"
        contentText="You won't be able to revert this!"
        onClose={closeDialog}
        actions={[
          {
            text: "Cancel",
            color: "primary",
            onClick: closeDialog,
          },
          {
            text: "Delete",
            color: "primary",
            onClick: handleDelete,
          },
        ]}
      />
    </>
  );
}
